export default "__VITE_ASSET__DTC1kD58__"